import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";

import { useSendEmailForm } from "./hooks/useSendEmailForm";

// ----------------------------------------------------------------------

export default function SendEmailForm() {
	const { translate } = useLocales();
	const { methods, onSubmit, loading } = useSendEmailForm();

	return (
		<FormProvider methods={methods} onSubmit={onSubmit}>
			<Stack spacing={3}>
				<RHFTextField label='Email' name='email' />
				<LoadingButton fullWidth loading={loading} size='large' type='submit' variant='contained'>
					{translate("Reiniciar contraseña")}
				</LoadingButton>
			</Stack>
		</FormProvider>
	);
}
